import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../CSS/Navigation.css';
import CVEnglish from '../assets/CV/CV_AkseliRajahalmeEnglish.pdf';
import CVFinnish from '../assets/CV/CV_AkseliRajahalmeFinnish.pdf';

import { ReactComponent as HamburgerIcon } from '../assets/icons/HamburgerMenuIcon.svg';
import { ReactComponent as CloseIcon } from '../assets/icons/CloseButtonIcon.svg';

import instagramIcon from '../assets/icons/instagram.svg';
import githubIcon from '../assets/icons/github.svg';

function Navigation() {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const [fadeIn, setFadeIn] = useState(false);
  const [cvDropdownOpen, setCvDropdownOpen] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setFadeIn(true), 100);
    return () => clearTimeout(timeout);
  }, []);

  const closeMenu = () => setOpen(false);

  const changeLanguage = () => {
    const newLanguage = i18n.language === 'en' ? 'fi' : 'en';
    i18n.changeLanguage(newLanguage);
  };

  const getLanguageButtonText = () => {
    return i18n.language === 'en' 
      ? t('languageSwitcher.switchToFinnish') 
      : t('languageSwitcher.switchToEnglish');
  };

  const toggleCvDropdown = () => {
    setCvDropdownOpen(!cvDropdownOpen);
  };

  const closeCvDropdown = () => {
    setCvDropdownOpen(false);
  };

  return (
    <>
      {/* Yläpalkki */}
      <nav className={`top-bar ${fadeIn ? 'fade-in' : ''}`}>
        <button className="hamburger" onClick={() => setOpen(!open)} aria-label={t('navigation.openMenu')}>
          <HamburgerIcon className="icon" />
        </button>
        <div className="d-flex align-items-center">
          <button
            className="contact-link me-3"
            onClick={() => {
              sessionStorage.setItem('scrollToContact', 'true');
              window.location.href = '/home';
            }}
          >
            {t('navigation.contact')}
          </button>
          <button
            className="contact-link"
            onClick={changeLanguage}
          >
            {getLanguageButtonText()}
          </button>
        </div>
      </nav>

      {/* Sivupalkki */}
      <div className={`side-nav ${open ? 'open' : ''}`}>
        <button className="close-btn" onClick={closeMenu} aria-label={t('navigation.closeMenu')}>
          <CloseIcon className="icon" />
        </button>
        <ul>
          <li><Link to="/home" onClick={closeMenu}>{t('navigation.home')}</Link></li>
          <li><Link to="/projects" onClick={closeMenu}>{t('navigation.portfolio')}</Link></li>
          <li><Link to="/blog" onClick={closeMenu}>{t('navigation.blog')}</Link></li>
          <li className="cv-dropdown-container">
            <button 
              className="cv-dropdown-toggle"
              onClick={toggleCvDropdown}
            >
              {t('navigation.resume')}
            </button>
            {cvDropdownOpen && (
              <div className="cv-dropdown-menu">
                <a 
                  href={CVEnglish} 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cv-dropdown-item fade-in-section"
                  onClick={() => { closeCvDropdown(); closeMenu(); }}
                >
                  {t('navigation.resumeEnglish')}
                </a>
                <a 
                  href={CVFinnish} 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cv-dropdown-item fade-in-section"
                  onClick={() => { closeCvDropdown(); closeMenu(); }}
                >
                  {t('navigation.resumeFinnish')}
                </a>
              </div>
            )}
          </li>
        </ul>

        {/* Sosiaalisen median ikonit */}
        <div className="social-icons">
          <a href="https://github.com/AkseliRaj" target="_blank" rel="noopener noreferrer" onClick={closeMenu}>
            <img src={githubIcon} alt="Github" className="social-icon" />
          </a>
          <a href="https://www.instagram.com/askeli.png/" target="_blank" rel="noopener noreferrer" onClick={closeMenu}>
            <img src={instagramIcon} alt="Instagram" className="social-icon" />
          </a>
        </div>
      </div>

      {/* Tumma overlay, näkyy vain kun valikko on auki */}
      {open && <div className="overlay" onClick={closeMenu}></div>}
    </>
  );
}

export default Navigation;
